/* eslint-disable max-len */
import React,{useState,useEffect} from 'react'
import AnimatedPage from '../../components/Animation/AnimatedPage'
import ErrorMessage from '../../components/ErrorMessage'
import Loader from '../../components/Loader'
import OtpInputField from '../../components/OtpInput'

export default function Otp({
    setIsLoginPage,
    setOtp,
    otp,
    error,
    seterror,
    handleLogin,
    handleOTPVerification,
    loading,
    handelClear,
    setloading}) {
    const [timer, setTimer] = useState(30);

    /* This `useEffect` hook is setting up a timer that counts down from 30 seconds and updates the
    `timer` state every second. It uses `setInterval` to create a new interval every second as long
    as `timer` is greater than 0. When the component unmounts or `timer` changes, it clears the
    interval using `clearInterval`. This is used in the `handleResendOTP` function to reset the
    timer to 30 seconds when the user clicks the "Resend OTP" button. */
    useEffect(() => {
        let intervalId;

        if (timer > 0) {
            intervalId = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        }

        return () => {
            clearInterval(intervalId);
        };
    }, [timer]);

    /**
     * The function `handleResendOTP` is used to handle the logic for resending an OTP (One-Time
     * Password) and resetting the timer to 30 seconds.
     */
    const handleResendOTP = () => {
    // Handle resend OTP logic here
    // Reset the timer to 30 seconds
        setTimer(30);
    };
    return (
        <AnimatedPage>
            <div className="w-full flex flex-col items-center h-screen shadow-s1 otp-screen show relative">
                                    
                <div className="ml-4 absolute top-[10%] left-0" onClick={() => {
                    handelClear();
                    setIsLoginPage(true);
                    seterror(false)
                    setloading(false)
                }}>
                    <a href="javascript:void(0)" className="flex items-center backBtnLogin">
                        <span><img src="images/back-btnBlue.svg" alt="btn" loading="lazy" /></span >
                        <span className="pl-3 text-lg font-[500] text-[#106EB4]">Back</span>
                    </a>
                </div>

                {/* <!-- otp screen --> */}
                <div className="mx-auto top-[15%] absolute">                    
                    <img src="images/SkuTeq-Logo.svg" alt="product-logo" className="mx-auto" loading="lazy"/>
                    <p className="text-center pt-[35px] text-xl font-semibold text-[#031624] otp-error">OTP Verification</p>
                    <div className="mx-auto">
                        <div className="w-[350px]">
                            <p className="pt-8 text-[#031624] text-center">An OTP has been sent to your registered email address and it will expire in 5 minutes</p>
                            <form onSubmit={(e)=>handleOTPVerification(e)}>
                                <p className="text-f1 font-[500] text-[#344054] pt-8">Enter OTP</p>
                                
                                <div className="digit-group flex justify-between pt-1.5">
                                    <OtpInputField
                                        onChange={setOtp}
                                        inputs={otp}
                                        setInputs={setOtp}
                                        value={otp}
                                        inputType="tel"
                                        shouldAutoFocus	
                                        inputStyle="w-14 h-12 border-b-2 sm:mr-6 mr-5 border-[#A9B2BE] bg-[transparent] outline-0 text-center text-xs4 font-normal otp-input err-otp text-[#0D1B2A]"
                                        numInputs={6}
                                        error={error}
                                        seterror={seterror}
                                        renderInput={(props) => <input {...props} />}
                                        separator={<span></span>}
                                    />
                                    {/* <!-- If it is a error state then border color will be "#ED1C24" --> */}
                                </div>
                                {/* <!-- error message --> */}
                                {error &&<ErrorMessage error={error} message="Invalid OTP. Please try again or request a new OTP" classKey="pt-1.5 text-f1 font-[400] text-[#F04438]" />}
                                {/* <p className="pt-1.5 text-f1 font-[400] text-[#F04438] otp-errMsg hidden">Invalid OTP. Please try again or request a new OTP</p> */}
                                <div className="flex flex-col justify-center w-full">
                                    <div className="flex justify-between items-center mt-2 pr-1">
                                        <p className={`text-f1 font-normL text-[#4D555B]`}>&nbsp;</p>
                                        {/* <!-- for disabled  text-[#B3BBC1]--> */}
                                        <button
                                            onClick={(e) => {
                                                handleLogin(e, 'resend');
                                                setOtp(Array(6).fill(""));
                                                handleResendOTP();
                                            }}
                                            disabled={timer > 0}
                                            type="button"
                                            className={`text-f1 ${timer === 0 ? 'text-[#106EB4]' : 'text-[#B3BBC1]'} font-normal resend-otp`}
                                        >
                                            {timer > 0
                                                ? `Resend OTP in 00:${timer.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })}`
                                                : 'Resend OTP'
                                            }
                                        </button>

                                    </div>
                                    {/* <!-- for enabled buton bg-[#106EB4] --> */}
                                    <button type="submit"
                                        id="otp-form"
                                        disabled={loading}
                                        className={`w-full ${loading ? 'bg-[#818E98]' : 'bg-[#106EB4]'} py-3 rounded mt-5 text-f2 font-normal text-[#ffffff] verify-btn hover:bg-[#1C8ADC] ltr-spcng-8`}>
                                        
                                        {!loading?'Verify OTP':<span>{<Loader />}</span>}

                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </AnimatedPage>
    )
}
